export const user = {
    id    : 'cfaad35d-07a3-4447-a6c3-d8c3d54fd5df',
    name  : 'Mr Admin',
    email : 'admin',
    avatar: 'assets/images/avatars/profile.jpg',
    status: 'online',
};
